var e={decreaseBtnLabel:"decrease",increaseBtnLabel:"increase",getCurrentQuantityAriaLabel:function(e){return"Current quantity is ".concat(e)},removeBtnLabel:"remove"};export{e as quantitySelectorTranslations};
